import React, { useState } from 'react';

const PhoneTest = () => {
  const [phone, setPhone] = useState('');

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and limit to 11 digits (worldwide mobile numbers)
    const cleanValue = value.replace(/\D/g, '').slice(0, 11);
    setPhone(cleanValue);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '400px' }}>
      <h2>Worldwide Phone Input Test</h2>
      <div className="phone-input-container">
        <div className="country-selector">
          <div className="country-display">
            <span className="country-code">PK</span>
            <span className="country-dial-code">+92</span>
          </div>
        </div>
        <input
          type="tel"
          value={phone}
          onChange={handlePhoneChange}
          placeholder="03001234567"
          pattern="03[0-9]{9}"
          maxLength="11"
          className="phone-number-input"
        />
      </div>
      <p>Entered Phone Number: {phone}</p>
      <p>Full Number: +92{phone.startsWith('0') ? phone.substring(1) : phone}</p>
      
      <h3>Instructions:</h3>
      <ol>
        <li>Enter your 11-digit mobile number</li>
        <li>Number should start with 03 (e.g., 03001234567)</li>
        <li>Only numbers are allowed</li>
      </ol>
    </div>
  );
};

export default PhoneTest;
